import { HorizontalRule as OriginalHorizontalRule } from "@tiptap/extension-horizontal-rule";
import { ReactNodeViewRenderer, NodeViewWrapper } from "@tiptap/react";

import { LineWrapper } from "@/components/tiptap/utils/line-wrapper/LineWrapper";
import { twMerge } from "@/utils/twMerge";

import type { DocumentModel } from "@/models/DocumentModel";
import type { NodeViewProps } from "@tiptap/react";

type HorizontalRuleExtensionOptions = {
  doc: DocumentModel;
};

const HorizontalRuleContent = ({ selected, extension, getPos }: NodeViewProps) => {
  const { doc } = extension.options as HorizontalRuleExtensionOptions;
  return (
    <NodeViewWrapper>
      <LineWrapper
        doc={doc}
        getPos={getPos}
        contentComponent="pre"
        contentClassName="flex-col items-stretch"
      >
        <hr
          contentEditable="false"
          className={twMerge(
            "w-full border-gray-400 dark:border-gray-600 h-1.5",
            selected && "border-icon-active dark:border-icon-active",
          )}
        />
      </LineWrapper>
    </NodeViewWrapper>
  );
};

export const HorizontalRule = OriginalHorizontalRule.extend<HorizontalRuleExtensionOptions>({
  addNodeView() {
    return ReactNodeViewRenderer(HorizontalRuleContent, {
      className: "w-full mx-auto max-w-content-width sm:max-w-full",
    });
  },
});
